import { render, staticRenderFns } from "./WriteOffCompanyRating.vue?vue&type=template&id=92a1c972"
import script from "./WriteOffCompanyRating.vue?vue&type=script&lang=js"
export * from "./WriteOffCompanyRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports